import partyService from "../services/partyService";

export default {
  namespaced: true,

  state: {
    channels: [],
    users: [],
    recipientParties: [],
    pendingChatUnreadCount: 0,
    sendbirdConnected: false,
  },

  mutations: {
    updateChannels(state, channels) {
      state.channels = [...channels];
    },
    updateUsers(state, users) {
      state.users = users;
    },
    updateRecipientParties: (state, recipientParties) => {
      state.recipientParties = recipientParties;
    },
    clearState(state) {
      state.channels = [];
      state.users = [];
      state.recipientParties = [];
      state.sendbirdConnected = false;
      state.pendingChatUnreadCount = 0;
    },
    incrementPendingChatUnread(state) {
      state.pendingChatUnreadCount++;
    },
    setPendingChatUnreadCount(state, count) {
      state.pendingChatUnreadCount = count;
    },
    setSendbirdConnected(state, connected) {
      state.sendbirdConnected = connected;
      if (connected) {
        state.pendingChatUnreadCount = 0;
      }
    },
  },

  getters: {
    channels: state => state.channels,
    users: state => state.users,
    recipientParties: state => state.recipientParties,
    pendingChatUnreadCount: state => state.pendingChatUnreadCount,
    sendbirdConnected: state => state.sendbirdConnected,
  },

  actions: {
    async updateRecipientParties({ commit }) {
      const parties = await partyService.getChatParties();
      commit("updateRecipientParties", parties);
    },
  },
};
